import map from 'lodash/map';
import includes from 'lodash/includes';
import { parseUrlChannel, channelObjects } from '../../../../shared/model/constants/channels';
import {
  searchWithinOptionsUnderSingleLocation,
  searchWithinOptionsUnderOtherSituation,
} from '../constants/extendSearchOptions';

const generateChannelOptions = () =>
  map(channelObjects, channel => ({
    value: channel.url,
    displayText: channel.displayInSelect,
  }));

const showTenureTypeByChannel = channel =>
  includes([channelObjects.ForSale, channelObjects.Sold], parseUrlChannel(channel));

// Matches whether location has a number
// e.g. 'in-melbourne+-+northern+region%2c+vic' versus 'in-richmond%2c+vic+3121'
const notRegion = locality => Boolean(locality.match(/\d+$/g));

const generateSearchWithinOptions = (locations) => {
  const locationsCount = locations ? locations.length : 0;
  return (locationsCount === 1 && notRegion(locations[0]))
    ? searchWithinOptionsUnderSingleLocation
    : searchWithinOptionsUnderOtherSituation;
};

export default {
  generateChannelOptions,
  showTenureTypeByChannel,
  generateSearchWithinOptions,
};
